module.exports = __webpack_public_path__ + "img/pp.2ee99ca7.png";